import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import { Wrapper, ListWrapper, ActivitiesItem } from './elements';
import Spa16 from 'dc/Spa16';
import { useFormatNumber, useGetActivityIconUrl } from 'common/hooks';

type Props = {
  readonly totalLoggedActivities: number;
};

const deps = {
  activities: state.appContainer.activities,
  activitiesCount: state.challenge.stats.total.challenge.activitiesCount,
};

export function ActivitiesList({
  activities,
  activitiesCount,
  totalLoggedActivities,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const formatNumber = useFormatNumber();
  const getActivityIconUrl = useGetActivityIconUrl();

  function getActivityItems() {
    const sortedActivityKeys = Object.keys(activitiesCount).sort(
      (currentActivityKey, nextActivityKey) => {
        const currentActivity = activitiesCount[currentActivityKey];
        const nextActivity = activitiesCount[nextActivityKey];

        return nextActivity - currentActivity;
      }
    );
    const [highestActivityKey] = sortedActivityKeys;
    const highestActivityPercent =
      (activitiesCount[highestActivityKey] / totalLoggedActivities) * 100;

    return sortedActivityKeys.map((activityKey, index) => {
      const activity = activities[activityKey];
      const percent =
        (activitiesCount[activityKey] / totalLoggedActivities) * 100;
      const percentageFactor = highestActivityPercent / 100;

      if (activitiesCount[activityKey] > 0 && activity) {
        return (
          <ActivitiesItem
            type={'activity'}
            iconImage={getActivityIconUrl(activity?.icon)}
            position={index + 1}
            labelText={activity.title}
            key={activityKey}
            percent={percent / percentageFactor}
            progressColor={'#0099a9'}
            value={formatNumber(activitiesCount[activityKey])}
            valueIcon={'icon-check_circle'}
          />
        );
      }

      return false;
    });
  }

  return (
    <Wrapper>
      <Spa16 />
      <ListWrapper>{getActivityItems()}</ListWrapper>
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, ActivitiesList);
